const Minus = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M20 13H4v-2h16v2z" fill="#000" />
    </svg>
)

export default Minus;